var render, staticRenderFns
import script from "./CLieBooking.vue?vue&type=script&lang=js&"
export * from "./CLieBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30be5d30')) {
      api.createRecord('30be5d30', component.options)
    } else {
      api.reload('30be5d30', component.options)
    }
    
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/CLieBooking.vue"
export default component.exports